var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-page"},[_c('div',{staticClass:"agreement-title"},[_vm._v("智能客服服务协议")]),_c('agreementContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }